import React from "react";
import IconSelect from "../../../../components/input/IconSelect";
import NewFormInputPhoneNumber from "../../../../components/input/NewFormPhoneNumber";
import IconInput from "../../../../components/input/IconInput";
import { DropdownToggleIcon } from "../../../../components/icons";

const PassengerName = ({
    t,
    pronounced,
    onChangeCartSelection,
    onChangeCartText,
    cart
}) => {
    const handleClickCountryList = (dialCode, countryCode, name) => {
        onChangeCartText({ target: { name: "passengerPrefixNumber", value: dialCode } })
        onChangeCartText({ target: { name: "passengerCountry", value: name } })
        onChangeCartText({ target: { name: "passengerCountryCode", value: countryCode } })
    };

    return (
        <div className="tw:!mb-5">
            <p className="tw:!mb-3 tw:!font-[500] tw:!text-[16px] tw:!noto">
                {t("BookingConfirmation.PassengerInformation.Title")}
            </p>
            <div className={`tw:relative tw:flex tw:flex-col tw:min-w-0 tw:bg-white tw:bg-clip-border tw:border tw:border-[rgba(0,0,0,0.125)] tw:rounded-[0.3rem]`}>
                <div className="tw:flex-1 tw:p-4">
                    {
                        false && (
                            <>
                                <div className="tw:!mb-6">
                                    <div className="tw:!flex tw:!gap-2 tw:!items-center tw:!justify-center">
                                        <div className="tw:w-full tw:!w-2/6 tw:md:!w-1/6">
                                            <p className="tw:!m-0 tw:!font-[400] tw:!text-[15px] noto">
                                                {t("BookingConfirmation.PassengerInformation.SelectPassenger")}
                                            </p>
                                        </div>
                                        <div className="tw:w-full tw:!w-4/6 tw:md:!w-5/6">
                                            <IconSelect
                                                options={[
                                                    { label: "Danial Abror", value: "Danial Abror" },
                                                    { label: "Jonathan Immanuel", value: "Jonathan Immanuel" },
                                                    { label: "Nakayama Yuki", value: "Nakayama Yuki" },
                                                ]}
                                                onSelect={(e) => console.log(e)}
                                                placeholder={t("BookingConfirmation.PassengerInformation.SelectPassengerPlaceholder")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="tw:!mb-6 tw:!flex tw:!items-center tw:!justify-center tw:gap-5">
                                    <hr className="tw:!bg-[#E8E8E8] tw:!border-0 tw:!flex-1" />
                                    <p className="tw:!m-0 tw:!font-[700] tw:!text-[14px] tw:!text-[#8D8D8D] tw:tracking-[0%] tw:text-center">
                                        {t("BookingConfirmation.PassengerInformation.divider")}
                                    </p>
                                    <hr className="tw:!bg-[#E8E8E8] tw:!border-0 tw:!flex-1" />
                                </div>
                            </>
                        )
                    }
                    <div className="tw:!mb-6">
                        <div className="tw:!mb-2">
                            <p className="tw:!m-0 tw:!font-[400] tw:!text-[15px] noto">
                                {t("BookingConfirmation.PassengerInformation.PassengerName")} &nbsp;
                                <span className="tw:text-[#dc3545]!">*</span>
                            </p>
                            <p className="tw:!m-0 tw:!font-[400] tw:!text-[13px] tw:!opacity-50 noto">
                                {t("BookingConfirmation.PassengerInformation.PassengerNameNote")}
                            </p>
                        </div>
                        <div className="tw:!flex tw:!gap-2">
                            <div className="tw:w-full tw:!w-2/6 tw:md:!w-1/6">
                                <IconSelect
                                    value={cart.passengerPronounced}
                                    options={[
                                        { label: "-", value: "-" },
                                        { label: "Mr.", value: "Mr." },
                                        { label: "Ms.", value: "Ms." },
                                        { label: "Mrs.", value: "Mrs." },
                                    ]}
                                    onSelect={(e) => onChangeCartSelection({ name: "passengerPronounced", value: e })}
                                />
                            </div>
                            <div className="tw:w-full tw:!w-4/6 tw:md:!w-5/6">
                                <IconInput
                                    value={cart.passengerName}
                                    onChange={(e) => onChangeCartText(e)}
                                    placeholder={t("BookingConfirmation.PassengerInformation.PassengerNamePlaceholder")}
                                    name="passengerName"
                                    height="50px"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="tw:!mb-3">
                        <div className="tw:!mb-2">
                            <p className="tw:!m-0 tw:!font-[400] tw:!text-[15px] noto">
                                {t("BookingConfirmation.PassengerInformation.PassengerPhoneNumber")} &nbsp;
                                <span className="tw:text-[#dc3545]!">*</span>
                            </p>
                            <p className="tw:!m-0 tw:!font-[400] tw:!text-[13px] tw:!opacity-50 noto">
                                {t("BookingConfirmation.PassengerInformation.PassengerPhoneNumberNote")}
                            </p>
                        </div>
                        <div className="tw:!flex tw:!gap-2">
                            <NewFormInputPhoneNumber
                                placeholder={t("BookingConfirmation.PassengerInformation.PassengerPhoneNumberPlaceholder")}
                                label={t("BookingConfirmation.PassengerInformation.PassengerPhoneNumberPlaceholder")}
                                selectCountryPlaceholder={t("SelectCountry.Placeholder")}
                                value={cart.passengerPhoneNumber}
                                countryCode={cart.passengerCountryCode ?? "JP"}
                                prefixPhoneNumber={cart.passengerPrefixNumber ?? "+81"}
                                onChange={(e) => onChangeCartText(e)}
                                handleClickCountryList={handleClickCountryList}
                                name="passengerPhoneNumber"
                                mb="mb-0 w-100"
                                isInvalid={false}
                                invalidMessage={"Please fill in phone number."}
                            />
                        </div>
                    </div>
                    {
                        false && (
                            <div className="tw:!mb-0 tw:!flex tw:!items-center tw:!gap-2">
                                <input
                                    className="tw:w-4 tw:h-4 tw:align-top tw:bg-white tw:border tw:border-[rgba(0,0,0,0.25)] tw:appearance-auto tw:accent-[#d4b055] tw:!m-0"
                                    type="checkbox"
                                    id="savePassengerInfo"
                                    checked={false}
                                />
                                <p
                                    className={` noto-sans tw:!m-0`} htmlFor="savePassengerInfo"
                                    dangerouslySetInnerHTML={{
                                        __html: t("BookingConfirmation.PassengerInformation.SavePassengerInfo"),
                                    }}
                                >
                                </p>
                            </div>
                        )
                    }
                </div>
            </div>
        </div>
    );
};

export default PassengerName;
